module.exports = __webpack_public_path__ + "static/img/josh-calabrese-Ca8r0PSWg9Q-unsplash.67b0289.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/josh-calabrese-Ca8r0PSWg9Q-unsplash.png
// module id = LO0v
// module chunks = 1